import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consentChoice = localStorage.getItem('cookie-consent');
    if (!consentChoice) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
    if (typeof window !== 'undefined' && (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag) {
      (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setShowBanner(false);
    if (typeof window !== 'undefined' && (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag) {
      (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      });
    }
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  // Bottom-right on desktop: the hero's primary CTAs live bottom-left, and the
  // banner used to sit directly on top of them at first paint.
  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-md">
      <Card className="p-4 shadow-xl border-border bg-card">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-2">
            <Cookie className="w-5 h-5 text-accent" />
            <h3 className="font-semibold text-foreground">Cookie Preferences</h3>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            className="h-6 w-6 p-0"
            aria-label="Close cookie preferences"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
        
        <p className="text-sm text-muted-foreground mb-4">
          We use cookies and similar technologies to analyze website traffic and improve your experience. 
          You can choose which cookies to allow.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            onClick={handleAcceptAll}
            variant="default"
            size="sm"
            className="flex-1"
          >
            Accept All
          </Button>
          <Button
            onClick={handleRejectAll}
            variant="outline"
            size="sm"
            className="flex-1"
          >
            Reject All
          </Button>
        </div>
        
        <p className="text-xs text-muted-foreground mt-3">
          For more details, see our{' '}
          <a
            href="/privacy"
            className="text-accent hover:underline"
          >
            Privacy Policy
          </a>
        </p>
      </Card>
    </div>
  );
};

export default CookieConsent;